import SEOHead from '@/components/SEOHead'
import {Home} from 'lucide-react'

interface NotFoundProps {
  navigate: (path: string) => void
}

function NotFound({ navigate }: NotFoundProps) {
  return (
    <div>
      <SEOHead
        title="Page Not Found"
        description="The page you are looking for could not be found on AdsROAS Calculator."
      />
      <section className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 py-24 text-center">
        <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-emerald-700">404 error</p>
        <h1 className="mt-3 text-3xl sm:text-4xl font-extrabold text-slate-900 tracking-tight">Page Not Found</h1>
        <p className="mt-4 text-[15px] text-slate-600 leading-relaxed max-w-md mx-auto">
          The page you are looking for does not exist or may have moved. Try one of our calculators instead.
        </p>
        <button
          onClick={() => navigate('/')}
          className="mt-8 inline-flex items-center gap-2 bg-emerald-600 hover:bg-emerald-700 text-white text-[13px] font-semibold px-5 py-2.5 rounded-lg shadow-sm shadow-emerald-600/20 transition-colors"
        >
          <Home className="w-4 h-4" />
          Back to Home
        </button>
      </section>
    </div>
  )
}

export default NotFound
